import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {ActivitiesDialogComponent} from './activities-dialog/activities-dialog.component';
import {ActivitiesLevelsDialogComponent} from './activities-levels-dialog/activities-levels-dialog.component';

@Component({
  selector: 'app-affirmations',
  templateUrl: './affirmations.component.html',
  styleUrls: ['./affirmations.component.scss']
})
export class AffirmationsComponent implements OnInit {
  pageTitle: any;

  constructor(public router: Router,
              public dialog: MatDialog) {
    this.pageTitle = 'Δηλώσεις';
  }

  ngOnInit(): void {
  }

 async navigateToActivities() {
    this.dialog.open(ActivitiesDialogComponent, {});
  }

  navigateToActivitiesLevels() {
    this.dialog.open(ActivitiesLevelsDialogComponent, {});
  }
}
